import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/App';
import { BrowserRouter as Router } from "react-router-dom";
import './index.css';

const root = createRoot(document.getElementById('root')!)
root.render(
  <React.StrictMode>
    <Router>
    <App />
    </Router>
  </React.StrictMode>
);